import { SVGAttributes } from 'react'

import styles from './Tick.module.scss'

interface TickProps extends Pick<SVGAttributes<SVGTextElement>, 'dy' | 'textAnchor' | 'x' | 'y'> {
  value: string
}

const Tick = ({ dy, value, ...svgProps }: TickProps) => (
  <text className={styles.tick} stroke="none" {...svgProps}>
    <tspan x={svgProps.x} dy={dy}>
      {value}
    </tspan>
  </text>
)

export default Tick
